import * as React from "react";
import { useTranslation } from "react-i18next";
import "./buttonViewStyles.css";
export var ScrollToTopButton = function () {
    var t = useTranslation().t;
    return (React.createElement("div", { className: "scroll-to-top-wrapper" },
        React.createElement("div", { className: "scroll-to-top-container" },
            React.createElement("div", { className: "scroll-to-top-icon" }),
            t("layout.scroll_to_top"))));
};



//////////////////
// WEBPACK FOOTER
// ./src/components/views/buttons/ScrollToTopButton.tsx
// module id = 25
// module chunks = 1